import React from 'react';
import { Link } from 'react-router-dom';

const HomeContact = () => {
    return (
        <div className='container mt-5 pb-5'>
        <div className='border shadow-lg p-4' data-aos="fade-right">
            <h2> Want to Contact With Me ?? </h2>
            <p>DISCUSS A PROJECT OR JUST WANT TO SAY HI? MY INBOX IS OPEN FOR ALL..</p>
            <p> +880-1632685828 </p>
            <p> Shishirsaha1530@gmail.com </p>
            <Link to='/contact' className='btn btn-success'> Send Message </Link>
        </div>
            
        </div>
    );
};

export default HomeContact;